import {BaseModel} from "../base";
import {deal} from "../../services/deal";

class DealModel extends BaseModel {

    static $query(company) {
        return deal.query(company);
    }
}

export {
    DealModel
}